import { Pipe, PipeTransform, inject } from '@angular/core';

import { LanguageService } from '../services/language.service';

/**
 * Impure pipe so it re-evaluates when LanguageService's `lang` signal
 * changes (Angular signals don't auto-mark impure-pipe-free pipes dirty
 * across OnPush boundaries the way an Observable + async pipe would).
 */
@Pipe({
  name: 'demoTranslate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly language = inject(LanguageService);

  transform(key: string): string {
    // Reading the signal here subscribes this pipe instance to changes.
    this.language.lang();
    return this.language.t(key);
  }
}
